/** The plot area of a chart, in pixels from the SVG's origin. */
export interface PlotArea {
    left: number;
    top: number;
    width: number;
    height: number;
}

/** The space a chart keeps around its plot for axes and labels, in pixels. */
export interface PlotMargin {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

/** The plot area left inside a chart box of `width` × `height` by `margin`; never negative. */
export function plotAreaWithin(
    width: number,
    height: number,
    margin: PlotMargin
): PlotArea {
    return {
        left: margin.left,
        top: margin.top,
        width: Math.max(width - margin.left - margin.right, 0),
        height: Math.max(height - margin.top - margin.bottom, 0),
    };
}
